export const discountTypes = {
    setIsReferralCodeEnabled: '[discount] sets the referral code enabled or not',
    setDiscount: '[discount] sets the discount % and description',
    setNoDiscountTotal: '[discount] sets the total with no discount',
    setDiscountTotal: '[discount] sets the total with discount',
    setActivePhase: '[discount] sets the active phase',
    setMyPhase: '[discount] sets my phase if any',
    setCalculating: '[discount] specifies if totals and discount are being calculated or not'
}